module.exports = __webpack_public_path__ + "media/images/about/bg05-0df51e60757ed327350a9a043927d4d5.jpg";